import Pagination from "@/modules/Common/Pagination"
import Breadcrumb from "@/modules/productPc/Breadcrumb"
import { getOctoCurations } from "@/service/api"
import { Link } from "gatsby"
import React, { FC, useEffect, useState } from "react"
import * as Styles from './article.module.scss'
import Loading from '@/layouts/Loading'
import SEO from "./seo"

interface IArticle {
  id: string
  author: string
  coverImage: string
  title: string
}

interface IProps {
  pageContext: {
    total: number,
    articles: IArticle[]
  }
}

const Articles: FC<IProps> = ({ pageContext }) => {
  let showLoading = false
  const START_ARTICLE_INDEX = 1300
  const [pageIndex, setPageIndex] = useState(0)
  const [totalNum, setTotalNum] = useState(pageContext.total || 0)
  const [breadCrumbList] = useState<any>(() => {
    return [
      { path: '/', term: '首页' },
      { path: '', term: '文章精选' },
    ]
  })

  // https://bieyangapp.com/curation/deal_20191031_lamerharrods/
  const [articles, setArticles] = useState<Array<IArticle>>(() => {
    return pageContext.articles || []
  })

  useEffect(() => {
    getCuratorPages()
  }, [pageIndex])


  /**获取curator页面列表 */
  function getCuratorPages() {
    if (showLoading) return
    showLoading = true
    // 从13000条开始， 新的都是react写的。
    getOctoCurations(START_ARTICLE_INDEX + pageIndex).then((res: any) => {
      showLoading = false
      setArticles(res.hits.map((item: any) => {
        return {
          id: item.summary.id,
          author: item.summary.authorLabel,
          title: item.summary.title,
          coverImage: `https://baleen-cdn-g.bybieyang.com/static/curation${item.summary.image}`
        }
      }))
      setTotalNum((res.totalHits - START_ARTICLE_INDEX * 20))
    }).catch(err => {
      showLoading = false
      console.log('err: ', err)
    })
  }

  function onChange(current: number, pageSize: number) {
    setPageIndex(current - 1)
  }

  return <section className={Styles.articles}>
    <SEO
        title={'别样海外购_用户文章频道 | 别样海外购 bieyangapp.com'}
        description={'别样海外购_用户文章频道 | 别样海外购 bieyangapp.com'}
        keywords={'别样海外购_用户文章频道 | 别样海外购 bieyangapp.com'}
      />
    <Breadcrumb cate={breadCrumbList} />
    <div className={Styles.articleList}>
      {
        articles.map(item => {
          // return <Link to={`/article/${item.id}/${encodeURIComponent(item.title)}`}>
          return <Link to={`/article/${item.id}`}>
            <div className={Styles.articleWrap}>
              <div className={Styles.content}>
                <div className={Styles.des}>The Webster</div>
                <div className={Styles.title}>{item.title}</div>
                <div className={Styles.avatar}>{`${item.author} ${item.author.includes('推荐') ? '' : '推荐'}`}</div>
              </div>
              <div className={Styles.imgWrap}>
                <img className={Styles.img} src={item.coverImage} alt="" />
              </div>
            </div>
          </Link>
        })
      }
    </div>
    <Pagination current={pageIndex + 1} onChange={onChange} totalNum={totalNum} pageSize={20} />
    {showLoading && <Loading />}
  </section>
}

export default Articles